module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_jianjie.235bb.png";